<template>
  <Notifications/>
  <nav class="navbar navbar-expand-lg bg-dark sticky-top mb-4 border-bottom py-1 px-1">
    <div class="container">

      <!-- Logo -->
      <a class="navbar-brand d-flex align-items-center text-white px-0" href="/" style="padding: 0;">
        <img src="/logo2sm.png" alt="Logo" class="navbar-brand-icon"/>
      </a>

      <!-- Main menu (left) -->
      <ul class="navbar-nav ms-2 align-items-center flex-row">

        <li class="nav-item mx-2">
          <router-link class="nav-link text-white" to="/visits" title="Посещаемость">
            <i class="bi bi-clipboard-data nav-icon me-2"></i>
          </router-link>
        </li>

        <li class="nav-item mx-2">
          <router-link class="nav-link text-white" to="/payouts/dashboard" title="Панель выплат">
            <i class="bi bi-cash-stack nav-icon me-2"></i>
          </router-link>
        </li>

        <li class="nav-item mx-2">
          <router-link class="nav-link text-white" to="/users/list" title="Пользователи - ВМ и сотрудники">
            <i class="bi bi-people-fill nav-icon d-inline me-2"></i>
          </router-link>
        </li>


        <li class="nav-item dropdown mx-2">
          <a
              class="nav-link text-white dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="Прочее"
          >
            <i class="bi bi-caret-down-fill nav-icon me-2"></i>
          </a>

          <ul class="dropdown-menu dropdown-menu-dark">
            <li><router-link class="dropdown-item" to="/receipt/payments"  title="Ребиллы, кассы Атолл и Чеки по Adfix">Флекси и Атолл</router-link></li>
            <li><router-link class="dropdown-item" to="/subs" title="Подписки">Подписки</router-link></li>
            <li><router-link class="dropdown-item" to="/tarifs" title="Тарифы">Тарифы</router-link></li>
            <li><router-link class="dropdown-item" to="/leadrules" title="Ставки за Лид">Ставки за Лид</router-link></li>
            <li><router-link class="dropdown-item" to="/platform/payment-generator" title="Генератор платежа">Генератор платежа</router-link></li>
            <li><router-link class="dropdown-item" to="/platform/report-generator" title="Генератор отчета">Генератор отчета</router-link></li>
          </ul>
        </li>

      </ul>


      <!-- Avatar (right) -->
      <ul class="navbar-nav ms-auto align-items-center flex-row">

        <li class="nav-item d-flex align-items-center spinner-wrapper">
          <span v-if="isl()" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <Avatar :user="user" @click="refresh" role="button" v-else/>
        </li>
      </ul>


    </div>
  </nav>
</template>

<script setup>
import {inject, computed} from 'vue'
import {useStore} from "@/state/store";
import Notifications from "@/components/Notifications.vue";
import {isl} from "@/helpers/h";
import Avatar from '@/components/Avatar.vue'

const store = useStore();
const emitter = inject('emitter');
const refresh = () => {
  emitter.emit('refresh')
}

const user = computed(() => store.getP('user'));
</script>

<style scoped>
.navbar, .navbar * {
  color: white !important;
  fill: white !important;
}

.spinner-wrapper {
  width: 35px;
  height: 35px;
}

.nav-link.dropdown-toggle::after {
  display: none !important;
}

.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #343a40 !important;
  color: #fff !important;
}

.nav-icon{
  font-size: 22px;
}

.nav-link {
  display: flex;
  align-items: center;
}

.dropdown-menu {
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  z-index: 1050 !important;
  min-width: 220px;
  margin-top: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15);
}

@media (max-width: 991px) {
  .navbar .dropdown-menu {
    left: auto !important;
    right: 0 !important;
    min-width: 220px;
  }
}

.exit-btn{
  font-size: 1.225rem;
  padding: 0 1rem;
}
</style>